import React from "react";
import NO_AVA from "styles/img/no-ava-card.png";
import Cpd_Cert from "styles/img/cpd_cert_ico.svg";
import moment from "moment";
import { Link } from "react-router-dom";
import {inject} from "mobx-react";

const COLOR = "#039ee5";
const GENERATE_SERTIFICATE = '/api/v1/pdfs/generate_certificate';

@inject('SponsorStore')
export default class CompletedItem extends React.Component {

  generateSertificate = () => {
    const url = `${GENERATE_SERTIFICATE}?workshop_id=${this.props.workshop.id}`;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    
    fetch(url, init)
    .then(resp => {
      if(resp.status=='200'){
      resp.blob()
      .then( file => {
      let objUrl = window.URL.createObjectURL(file)
        const open = window.open(objUrl)
        if (open == null || typeof(open)=='undefined')
            alert("Turn off your pop-up blocker!\n\n");
    })
    }
    else {
      alert('Something went wrong. Please check your connection or try again later')
    }
    })
  }

  linkPath = (id) => {
    if (window.location.href.includes('iacp'))
      return `/iacp/details/${id}`;
    else if (window.location.href.includes('aci'))
      return `/aci/details/${id}`;
    else if(this.props.workshop.workshop_type === 'live') {
      return `/details/webinar/${id}`;
    } else if(this.props.workshop.workshop_type === 'group_supervision') {
      return `/details/public_webinars/${id}`;
    } else if(this.props.workshop.workshop_type === 'public_workshop') {
      return `/details/public_workshops/${id}`;
    } else {
      return `/details/online/${id}`;
    }
  }

  render() {
    let el = this.props.workshop;
    return (
      <div className="col-12 col-md-6">
        <div className="card regular card-bottom-gutter">
          <div className="card-top-wrap">
            <div className="card-head">
              <div className="card-head-top">
                <div className="card-head-avatar-holder">
                  <div className="card-head-avatar">
                    {el.provider_logo_url ? (
                      <img src={el.provider_logo_url} alt="avatar" />
                    ) : (
                        <img src={NO_AVA} alt="avatar" />
                      )}
                  </div>
                  <div className="card-head-name-holder">
                    <span className="card-head-title">PROVIDED BY</span>
                    <span className="card-head-name">{el.provided_by}</span>
                  </div>
                  <div className="card-head-completed">
                    <span className="completed">completed</span>
                    <span className="date">{moment(el.completed_at).format('D MMM`YY')}</span>
                  </div>
                </div>
              </div>
              <p className="card-title">{el.title}</p>
            </div>
            <div className="card-content">
              <p className="card-desc">{el.summary ? el.summary : el.description.substr(0, 180)}</p>
            </div>
          </div>
          <div className="card-footer">
            <div className="card-footer-top">
              <ul className="suitableFor">
                <li key="wdw">
                  {' '}
                  <p className="card-info-title">Suitable for: </p>
                </li>
                {el.target_audience.map((element, i) => (
                  <li key={i}>
                    <span style={{ color: COLOR, marginLeft: 1 }}>
                      {element}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="card-footer-bottom">
              <ul className="card-info" style={{ display: "grid" }}>
                <li>
                  <p className="card-info-title">
                    MODULES:
                    <span
                      className="card-info-sub"
                      style={{ color: COLOR, marginLeft: 5 }}
                    >
                      {el.modules_count}
                    </span>
                  </p>
                </li>
                <li>
                  <p className="card-info-title">
                    CPD Hours:
                    {el.how_many_hours ? (
                      <span
                        className="card-info-sub"
                        style={{ color: COLOR, marginLeft: 5 }}
                      >
                        {el.how_many_hours}
                      </span>
                    ) : (
                        <span style={{ marginLeft: 5 }}>
                          'Check with provider'
                      </span>
                      )}
                  </p>
                </li>
              </ul>
              {/* TODO START - add condition */}
              {/* {el.workshop_type !== 'group_supervision' ? */}
                <button
                  className="btn bordered card-btn cert-download"
                  onClick={() => this.generateSertificate() }
                >
                  <img src={Cpd_Cert} alt="cert" />
                  <span>Certificate of Completion</span>
                </button>
              {/* } */}
              {/* TODO END */}
              <Link
                // to={`details/online/${el.id}`}
                to={this.linkPath(el.id)}
                className="btn bordered success card-btn"
              >
                COMPLETED
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const CPD_FALSE = (
  <svg width="10" height="9">
    <path
      fill="#FF524F"
      fillRule="evenodd"
      d="M2.292.758L.947 2.104l2.7 2.7-2.7 2.7L2.292 8.85l2.701-2.7 2.7 2.7 1.346-1.346-2.701-2.7 2.701-2.7L7.693.758l-2.7 2.701L2.292.758"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/completed_workshops/CompletedItem.jsx